import React from 'react'
import { Box, Progress } from '@chakra-ui/react'
import useTileLoading from "../../../hooks/useTileLoading"

const ProgressBox = React.memo(({ isTileLoading }) => {

  return isTileLoading ? (<Box
    position="absolute"
    right={0}
    top={0}
    width={"100%"}
    zIndex="1000">
    <Progress size="xs"  isIndeterminate />
  </Box>) : null
})

export default function MapSpinner() {
  const { isTileLoading } = useTileLoading()

  return <ProgressBox isTileLoading={isTileLoading}></ProgressBox>
}
